<template>
  <div>
    <div class="list" v-if="question.length">
      <div class="item">
        <div class="item-title">你的年龄</div>
        <div class="item-input-content" @click="bindShowAge()">
          <div class="i-left"
            ><span v-if="age">{{ age }}岁</span
            ><span v-else class="placeholder">请填写</span></div
          >
          <div class="iconfont icon-you"></div>
        </div>
      </div>
      <div class="item">
        <div class="item-title">身高体重</div>
        <div class="item-input-content" @click="bindWeightHeight()">
          <div class="i-left"
            ><span v-if="height">{{ height }}CM,</span
            ><span v-if="weight">{{ weight }}KG</span
            ><span v-if="!height && !weight" class="placeholder"
              >请填写</span
            ></div
          >
          <div class="iconfont icon-you"></div>
        </div>
      </div>
      <div class="item">
        <div class="item-title">目标体重</div>
        <div class="item-input-content" @click="bindShowTargetWeight()">
          <div class="i-left"
            ><span v-if="target_weight">{{ target_weight }}KG</span
            ><span v-else class="placeholder">请填写</span></div
          >
          <div class="iconfont icon-you"></div>
        </div>
      </div>
    </div>
    <AgeRuler
      v-model="showAgeRuler"
      @confirm="bindConfirmAge"
      :defaultNum="age"
    />
    <TargetWeightRuler
      v-model="showTargetWeightRuler"
      @confirm="bindConfirmTargetWeight"
      :weight="weight"
      :target_weight="target_weight"
    />
    <HeightWeightRuler
      v-model="showHeightWeightRuler"
      @confirm="bindConfirmHeightWeight"
      :height="height"
      :weight="weight"
      :gender="gender"
    />
  </div>
</template>
<script>
import AgeRuler from './ruler/age-ruler.vue'
import TargetWeightRuler from './ruler/target-weight-ruler.vue'
import HeightWeightRuler from './ruler/height-weight-ruler.vue'
export default {
  props: {
    question: {
      type: Array,
      default: () => []
    }
  },
  components: {
    AgeRuler,
    TargetWeightRuler,
    HeightWeightRuler
  },
  data() {
    return {
      gender: '',
      age: 0,
      height: 0,
      weight: 0,
      target_weight: 0,
      showAgeRuler: false,
      showTargetWeightRuler: false,
      showHeightWeightRuler: false
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.gender = this.question[this.findIndexByname('sex')].value
      this.age = this.question[this.findIndexByname('age')].value || 0
      this.height = this.question[this.findIndexByname('height')].value || 0
      this.weight = this.question[this.findIndexByname('weight')].value || 0
      this.target_weight =
        this.question[this.findIndexByname('nutritional_goal_weight')].value ||
        0
    },
    findIndexByname(name) {
      let index = this.question.findIndex((item) => {
        return item.field == name
      })
      return index
    },
    bindShowAge() {
      this.showAgeRuler = true
    },
    bindShowTargetWeight() {
      this.showTargetWeightRuler = true
    },
    bindWeightHeight() {
      this.showHeightWeightRuler = true
    },
    bindConfirmAge(value) {
      this.age = value
      this.question[this.findIndexByname('age')].value = +value
      this.$emit('change')
    },
    bindConfirmTargetWeight(value) {
      this.target_weight = value
      this.question[this.findIndexByname('nutritional_goal_weight')].value =
        value
      this.$emit('change')
    },
    bindConfirmHeightWeight(data) {
      this.height = data.height
      this.weight = data.weight
      this.question[this.findIndexByname('height')].value = data.height
      this.question[this.findIndexByname('weight')].value = data.weight
      this.$emit('change')
    }
  }
}
</script>
<style lang="scss" scoped>
.list {
  padding: 144px 65px 80px;

  .item {
    margin-bottom: 44px;

    .item-title {
      font-size: 15px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #0d0d0d;
      line-height: 22px;
      margin-bottom: 10px;
    }

    .item-input-content {
      position: relative;
      height: 46px;
      background: #ffffff;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.03);
      border-radius: 23px;
      padding: 0px 15px 0px 20px;
      display: flex;
      align-items: center;

      .i-left {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        font-size: 15px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #0d0d0d;
        text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.03);

        .placeholder {
          font-size: 15px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: rgba(13, 13, 13, 0.26);
          line-height: 22px;
          text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.03);
        }
      }

      .iconfont {
        font-size: 14px;
        color: #0d0d0d;
      }
    }
  }

  .item:last-child {
    margin-bottom: 0;
  }
}
</style>
